<template>
    <div class="relative" :style="{height: `${height}px`}">
        <span v-intersect="intersectConfig"/>
        <div class="toolbar w-full" :style="style">
            <div class="toolbar__content absolute left-0 right-0 w-full bg-white h-full">
                <container ref="content" class="relative h-full" full :custom-padding="customPadding">
                    <div class="flex items-center relative h-full w-full">
                        <slot/>
                    </div>
                </container>
            </div>
        </div>
    </div>
</template>
<script>
export default {

    name: 'HeaderToolbar',

	emits: ['sticky-change'],

    props: {
        // The height of the toolbar
        // This is required to prevent CLS when transitioning from relative to sticky
        height: {
            type: [String, Number],
            default: 42
        },

        // A custom padding of the container to overwrite the default
        customPadding: {
            type: String,
            default: null
        },

        // Whether the toolbar shall be fixed below the header
        sticky: {
            type: Boolean,
            default: false
        },

        // Whether the toolbar shall be fixed below the header on mobile devices
        stickyMobile: {
            type: Boolean,
            default: false
        },

        stickyOffset: {
            type: Number,
            default: 56 // Header height
        }
    },

    data() {
        return {
            isSticky: false
        }
    },

    computed: {
        intersectConfig() {
            return this.stickyMobile || this.sticky ? {handler: this.onIntersect, options: {rootMargin: `-${this.stickyOffset + 1}px 0px 0px 0px`}} : null; // stickyOffset + 1 to immediately trigger for initially sticky toolbars
        },

        style() {
            const style = {height: `${this.height}px`};

            if (this.isSticky) {
                style.position = 'fixed';
                style.top = `${this.stickyOffset}px`
                style.boxShadow = '1px 3px 6px -3px rgba(0, 0, 0, 0.1)';
                style.zIndex = 51; // Above header for shadow overlay
            } else {
                style.position = 'relative'
            }

            return style;
        }
    },

    watch: {
        isSticky(isSticky) {
            this.$emit('sticky-change', isSticky)
        }
    },

    methods: {
        onIntersect(isIntersecting) {
            if (this.sticky || (this.stickyMobile && this.$breakpoint.xsOnly)) {
                this.isSticky = !isIntersecting
            } else {
                this.isSticky = false
            }
        }
    }
}
</script>
<style>
.toolbar > .toolbar__content {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
</style>